"use client";

import { useEffect } from "react";
import { redirect } from "next/navigation";

export default function NotFound() {
  useEffect(() => {
    redirect(window.globalConfig.LINKED_PAGES.NOTFOUND);
  }, []);
  return <></>;
}
